export default "__VITE_ASSET__VEBgSXsU__"